import defaultAvatar from '@/assets/defaultAvatar.png'
import Index from './main.vue'
import { ref, reactive, Ref } from 'vue'

export const useAvatar = (options: {
  avatar: string | undefined
  groupId: number
  allowUpload?: Ref<boolean>
}) => {
  const avatarModel = ref<string>(options.avatar || defaultAvatar)
  const props = ref({
    groupId: options.groupId,
    allowUpload: options.allowUpload ?? true
  })
  return reactive({
    avatarModel,
    props
  })
}

export default Index
